const userStore = require("stores/UserStore");
const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const {pluckKeysExcept} = require("helpers/object");
const moment = require("moment");
const Loader = require("components/mixins/Load");
const {renderEmoji} = require("helpers/renderEmoji");

/*
 -------------------------------
 Methods
 -------------------------------
 */

function isSender(user) {
	return user.id === userStore.get("id");
}

function isSent(message) {
	return isSender(message.sender);
}

function isRead(message) {
	// sent messages are always read
	if (isSent(message)) {
		return true;
	}

	return message.states.filter(state => (state.user_id === userStore.get("id")) && state.read_at).length > 0;
}

/*
 -------------------------------
 Component
 -------------------------------
 */

class Message extends Component {

	static get propTypes() {
		return {
			id: PropTypes.number.isRequired,
			type: PropTypes.string.isRequired,
			contents: PropTypes.string.isRequired,
			handleAction: PropTypes.func
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			loading: false
		};
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get className() {
		return classList(
			"msg",
			`msg-${this.props.type}`,
			this.props.className,
			this.state.loading && "loading"
		);
	}

	get style() {
		return {whiteSpace: "pre-wrap"};
	}

	get content() {
		return renderEmoji(this.props.contents, true);
	}

	get innerHtml() {
		return {__html: this.content};
	}

	/////////////////////////////////
	// Helpers
	/////////////////////////////////

	setLoading(loading = true) {
		this.setState({loading});
	}

	actionListener(action) {
		return e => {
			e.preventDefault();
			e.stopPropagation();

			this.setLoading(true);

			if (typeof this.props.handleAction === "function") {
				const response = this.props.handleAction(action, this.props.id);

				if (response && typeof response.then === "function") {
					return response
						.then(() => this.setLoading(false))
						.catch(() => this.setLoading(false));
				}
			}

			this.setLoading(false);
		};
	}

	/////////////////////////////////
	// Rendering
	/////////////////////////////////

	renderGeneric() {
		return (
			<div style={this.style} className={this.className} dangerouslySetInnerHTML={this.innerHtml}/>
		);
	}

	renderBooking() {
		const params = this.props.params;

		const bookingFrom = moment(params.booking.from);
		const bookingTo = moment(params.booking.to);

		return (
			<div className={this.className}>
				<div className="msg-contents" dangerouslySetInnerHTML={this.innerHtml}/>
				<div className="msg-request">
					<div className="msg-times">
						<span>{bookingFrom.format("DD[.] MMMM")} / {bookingFrom.format("HH:mm")}
							- {bookingTo.format("HH:mm")}</span>
					</div>
				</div>
			</div>
		);
	}

	renderBookingRequest() {
		// data
		const {status} = this.props.booking_request || '';
		const params = this.props.params;

		const bookingFrom = moment(params.original.from);
		const bookingTo = moment(params.original.to);
		const mutationFrom = moment(params.mutation.from);
		const mutationTo = moment(params.mutation.to);

		// states
		const answerable = !isSender(this.props.sender) && (status === "pending");
		const responsive = answerable && !this.state.loading;
		const className = classList(this.className, answerable && "answerable", status);

		return (
			<div className={className}>
				<Loader/>
				<div className="msg-contents" dangerouslySetInnerHTML={this.innerHtml}/>
				<div className="msg-request">
					<div className="msg-times">
						<span>{bookingFrom.format("DD[.] MMMM")} / {bookingFrom.format("HH:mm")}
							- {bookingTo.format("HH:mm")}</span>
						<span>{mutationFrom.format("DD[.] MMMM")} / {mutationFrom.format("HH:mm")}
							- {mutationTo.format("HH:mm")}</span>
					</div>
					<div className="msg-actions">
						<button type="button" className="btn-accept" disabled={!responsive}
										onClick={this.actionListener("accept")}/>
						<button type="button" className="btn-reject" disabled={!responsive}
										onClick={this.actionListener("reject")}/>
					</div>
				</div>
			</div>
		);
	}

	render() {
		switch (this.props.type) {
			case "booking_request":
				return this.renderBookingRequest();

			case "booking":
				return this.renderBooking();

			default:
				return this.renderGeneric();
		}
	}

}

module.exports = {
	isSender,
	isSent,
	isRead,
	Message
};



// WEBPACK FOOTER //
// ./resources/js/components/backend/chat/Message.js